var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17_3)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.01,
    d: "M20.0015 -0.000793457H0.0014801V19.9992H20.0015V-0.000793457Z",
    fill: "url(#paint0_linear_17_3)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.71002 15.2904C0.974466 11.5549 0.645766 6.09175 3.9027 1.93323L4.1177 1.6669L7.60465 5.15385L7.49188 5.31373C5.90405 7.64057 6.4741 10.1863 8.14411 11.8563C9.79506 13.5072 12.3017 14.0832 14.6068 12.5622L14.8466 12.3958L18.3336 15.8827L18.0136 16.1393L17.9581 16.1822C13.8136 19.3487 8.413 18.9934 4.71002 15.2904Z",
    fill: "url(#paint1_linear_17_3)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_17_3",
    x1: 0.00147963,
    y1: 19.9992,
    x2: 19.9468,
    y2: 2.62877,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40E0CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.715921,
    stopColor: "#36CDCF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_17_3",
    x1: 1.66688,
    y1: 18.3336,
    x2: 18.288,
    y2: 3.8582,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40E0CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.715921,
    stopColor: "#36CDCF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17_3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/Call.1546bb4fa5f2ef9e17be16583ba1972e.svg";
export { ForwardRef as ReactComponent };